import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-setting',
  templateUrl: './page-setting.component.html',
  styleUrls: ['./page-setting.component.sass']
})
export class PageSettingComponent implements OnInit {

  coverPhoto: string = "./assets/img/cover.png";
  
  constructor() { }

  ngOnInit(): void {
  }

}
